<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-md-9 pb-5 text-center text-md-left">
                        
                        <div class="mb-5 text-center">
                            <img src="img/brand/white.png" style="width: 200px;" class="img-fluid">
                        </div>

                        <card type="secondary" shadow
                            header-classes="bg-white pb-5"
                            body-classes="px-lg-5 py-lg-5"
                            class="border-0 text-center">
                            <div class="card-body">
                                <h3 class="card-title mb-2">
                                    Muchas gracias!!!
                                </h3>
                                <h5 class="card-title mb-4">
                                    Aquí te dejo el link para que descargas tu copia
                                </h5>
                                <base-button tag="a"
                                    href="https://drive.google.com/file/d/1YtLCfD9_F4eFpHp5GjoQJG_15e5-s-F7/view?usp=sharing"
                                    class="mb-4"
                                    type="primary"
                                    icon="fa fa-download"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    Descargar libro Ahora
                                </base-button>
                                <p class="card-text">
                                    Quedo a tu disposición por cualquier comentario o consulta que me quieras hacer. <br>  Que tengas un gran día.
                                </p>
                                <p class="card-text font-weight-bold">
                                    Adriana 💛
                                </p>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
